import React from 'react';
import { Button, Nav, Navbar } from 'react-bootstrap';
import '../../../App.css';
import { TbLogout2 } from 'react-icons/tb';
import { Link, useNavigate } from 'react-router-dom';
import { BiSolidHome, BiSolidPlaneAlt, BiSolidUser, BiSolidUserCircle } from 'react-icons/bi';
import '../../../localization/Localization';
import { strings } from '../../../localization/Localization';
import { useAuth } from '../../Auth/AuthContext';

const Header = () => {

  const setLanguageToEnglish = () => {
    strings.setLanguage('en');
    localStorage.setItem('activeLanguage', 'en');
    window.location.reload();
  };

  const setLanguageToMacedonian = () => {
    strings.setLanguage('mk');
    localStorage.setItem('activeLanguage', 'mk');
    window.location.reload();
  };

  const {
    currentUser,
    isAuthenticated,
    isAdmin,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <>
      <header className='header sticky-top'>
        <Navbar collapseOnSelect expand='lg'
                className='navbar navbar-expand-lg bg-light-gray navbar-light py-3 py-lg-0 px-lg-5'>
          <div className='container-fluid p-2'>
            <h1 className='heading me-3 color-dark-blue'><i>{strings.AtlantikTurs}</i></h1>
            <Navbar.Toggle aria-controls='responsive-navbar-nav'/>
            <Navbar.Collapse id='responsive-navbar-nav'>
              <Nav className='me-auto mb-2 mb-lg-0'>
                <Nav.Link as={Link} to='/home'>
                  <div className='d-flex color-dark-blue'>
                    <span className='me-1'>{strings.home}</span>
                    <span className='d-flex mt-auto mb-auto'>
                      <BiSolidHome/>
                    </span>
                  </div>
                </Nav.Link>
                <Nav.Link as={Link} to='/clients'>
                  <div className='d-flex color-dark-blue'>
                    <span className='me-1'>{strings.clients}</span>
                    <span className='d-flex mt-auto mb-auto'>
                      <BiSolidUser/>
                    </span>
                  </div>
                </Nav.Link><Nav.Link as={Link} to='/excursions'>
                <div className='d-flex color-dark-blue'>
                  <span className='me-1'>{strings.excursions}</span>
                  <span className='d-flex mt-auto mb-auto'>
                      <BiSolidPlaneAlt/>
                    </span>
                </div>
              </Nav.Link>
                {isAdmin && (
                  <Nav.Link as={Link} to='/employees'>
                    <div className='d-flex color-dark-blue'>
                      <span className='me-1'>{strings.employees}</span>
                      <span className='d-flex mt-auto mb-auto'>
                      <BiSolidUserCircle/>
                    </span>
                    </div>
                  </Nav.Link>
                )}
              </Nav>
              <div>
                <div className={'d-flex align-items-start left-space me-2'}>
                  <div onClick={setLanguageToMacedonian}
                       className='btn btn-sm btn-outline-secondary m-sm-1 language-btn'
                  >MK
                  </div>
                  <div onClick={setLanguageToEnglish} className='btn btn-sm btn-outline-secondary m-sm-1 language-btn'
                  >EN
                  </div>
                </div>
              </div>
              <Nav>
                {isAuthenticated && (
                  <><span
                    className={'mt-auto mb-auto me-2 color-dark-blue'}>{strings.loggedInAs}<b>{currentUser?.username || ''}</b></span>
                    <Button onClick={handleLogout}>{strings.logout}<TbLogout2 size={20} className={'mt-auto mb-auto ms-1 '}/></Button>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </header>
    </>

  );
};

export default Header;
